import { render } from "./FooterSave.vue?vue&type=template&id=121b62c3&scoped=true"
import script from "./FooterSave.vue?vue&type=script&lang=js"
export * from "./FooterSave.vue?vue&type=script&lang=js"

import "./FooterSave.vue?vue&type=style&index=0&id=121b62c3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121b62c3"]])

export default __exports__